import { render, staticRenderFns } from "./FullTextReviewStageCard.vue?vue&type=template&id=07035f15&"
import script from "./FullTextReviewStageCard.vue?vue&type=script&lang=js&"
export * from "./FullTextReviewStageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports